<template>
    <div
        v-show="is_visible"
        class="fixed inset-x-0 bottom-0 z-50 flex flex-col items-center p-3 m-3 rounded shadow-lg md:px-6 bg-blue-bg-darker md:mx-auto md:max-w-lg md:flex-row"
    >
        <div class="flex-grow mb-3 text-lg text-white font-noto-sans md:mb-0 md:pr-6">
            Any questions? We'll call you.
        </div>

        <div class="flex flex-col flex-none w-full md:w-auto md:flex-row-reverse">
            <callback-requests-create-button
                class="flex-none w-full mb-3 md:mb-0 btn btn-blue md:w-auto"
                @open="onConfirm"
            >
                Request a callback
            </callback-requests-create-button>

            <button
                type="button"
                class="flex-none w-full text-white btn btn-transparent bg-white-10a md:w-auto md:mr-3"
                @click.prevent="onDeny"
            >
                No, thanks
            </button>
        </div>
    </div>
</template>

<script>
    import cookie from '../store/cookie'
    import CallbackRequestsCreateButton from '../components/callback-requests-create-button'

    const COOKIE_NAME = 'seen-request-callback-notice'

    export default {
        components: {
            CallbackRequestsCreateButton
        },
        data () {
            return {
                is_visible: false
            }
        },
        mounted () {
            if (!cookie.has(COOKIE_NAME)) {
                setTimeout(() => {
                    this.is_visible = true
                }, 20000)
            }
        },
        methods: {
            onConfirm () {
                this.$track(
                    'the-request-callback-notice',
                    'confirm',
                    this.$route.name || this.$route.path
                )

                this.close()
            },
            onDeny () {
                this.$track(
                    'the-request-callback-notice',
                    'deny',
                    this.$route.name || this.$route.path
                )

                this.close()
            },
            close () {
                cookie.set(COOKIE_NAME, true, { expires: 365 })

                setTimeout(() => {
                    this.is_visible = false
                }, 0)
            }
        }
    }
</script>
